/** Normalize patient status from API/DB to numeric id (2=Active, 3=Pending, 4=Locked).
 * Legacy Inactive (1) is treated as Locked for patient workflows.
 */
export function normalizePatientStatusId(raw) {
  if (raw === null || raw === undefined || raw === '' || raw === 0 || raw === '0') return 2;
  if (typeof raw === 'number') {
    if (raw === 1) return 4; // legacy Inactive → Locked
    if (raw === 3) return 3;
    if (raw === 4) return 4;
    return 2;
  }
  const txt = String(raw).trim().toLowerCase();
  if (txt === 'inactive' || txt === '1' || txt === 'i') return 4;
  if (txt === 'pending' || txt === '3' || txt === 'p') return 3;
  if (txt === 'locked' || txt === 'lock' || txt === '4' || txt === 'l' || txt === 'lost') return 4;
  if (txt === 'active' || txt === '2' || txt === 'a') return 2;
  return 2;
}

/**
 * Sort rank for patient status lists.
 * Ascending = Active → Pending → Locked (A, P, L).
 * Descending = Locked → Pending → Active (L, P, A).
 */
export function getPatientStatusSortOrder(raw) {
  const id = normalizePatientStatusId(raw);
  if (id === 3) return 2; // Pending
  if (id === 4) return 3; // Locked
  return 1; // Active
}

/** Resolve status from common patient row field names. */
export function resolvePatientStatusRaw(patient) {
  if (!patient || typeof patient !== 'object') return null;
  return patient.status ?? patient.status_id ?? patient.patient_status ?? patient.status_numeric ?? null;
}

export function patientStatusLabel(status) {
  const id = normalizePatientStatusId(status);
  if (id === 3) return 'Pending';
  if (id === 4) return 'Locked';
  return 'Active';
}

/** Patient add/edit forms expose Active, Pending, Locked only. */
export function patientStatusFormValue(status) {
  return patientStatusLabel(status);
}

export const PATIENT_STATUS_OPTIONS = [
  { value: 'Active', label: 'Active' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Locked', label: 'Locked' }
];

export const PATIENT_STATUS_FILTER_OPTIONS = [
  { value: '2', label: 'Active' },
  { value: '3', label: 'Pending' },
  { value: '4', label: 'Locked' }
];
